import React, { useEffect, useState } from 'react'
import { getAlertData } from '../../../../helper/sweet-alert';
import { ISendMail } from '../../../../models/common/IUserProfile';
import { IFinancialAssistanceCompose } from '../../../../models/student/studentAccountsDetails';
import { createFeedback, getToMailId } from '../../../../action/common/commonActionCreator';
import { connect, useDispatch } from 'react-redux';
import { UserRole } from '../../../../constants/RoleEnum';
import { emailBlockId } from '../../../../constants/pageBlocks';
import SweetAlert from 'react-bootstrap-sweetalert';
import { setToMailId } from '../../../../store/slices/common/commonSlice';
import { BarLoader } from 'react-spinners';
import { mailValidation } from '../../../../common-functions/commonFunctions';

const FinancialAssistanceCompose = (props: IFinancialAssistanceCompose) => {
    const { setShowCompose, sendMail, toMailId, getToMailId, currentUser } = props;

    const [content, setContent] = useState<string>("");
    const [subject, setSubject] = useState<string>("");
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [alertType, setAlertType] = useState<any>("success");
    const [alertTitle, setAlertTitle] = useState<string>("Default");
    const [showAlertCancel, setShowAlertCancel] = useState<boolean>(false);
    const dispatch = useDispatch()

    useEffect(() => {
        getToMailId(emailBlockId.Financial_Assistance);
        return () => {
            dispatch(setToMailId(""));
        }
    }, [])

    const setAlert = (type: string) => {
        let alertData = getAlertData(type);
        if (alertData) {
            setShowAlert(true);
            setAlertType(alertData.type);
            setAlertTitle(alertData.title);
        }
    };

    const handleSendMail = () => {

        let alertData = mailValidation(subject,content,[toMailId])
            if (alertData) {
              setShowAlert(true);
              setAlertType(alertData.type);
              setAlertTitle(alertData.title);
              return
          }
        
        const mailData: ISendMail = {
            toEmail: [toMailId],
            subject: subject,
            content: `${content}\<br>\<br>Regards,\<br>${currentUser.displayName}\<br>${currentUser.currentRole && UserRole[currentUser.currentRole]}`,
        };
        sendMail(mailData, setAlert);
    };

    const onConfirm = () => {
        setShowAlert(false);
    };
    return (
        <>
            <div className="modal-body">
                <h2>Compose</h2>
                <div className="emailform mt-3">
                    <div className="label-to">
                        <label htmlFor="">From</label>
                        <div className="stude-details">
                            <div className="img">
                                <img src="/assets/images/profile06.jpg" alt="" />
                            </div>
                            <div className="desc">
                                <h6>{currentUser.displayName}</h6>
                                <p>{currentUser?.currentDepartment?.name} | <span>{currentUser?.currentCollege?.name}</span></p>
                            </div>
                        </div>
                    </div>
                    <div className="formgroup">
                        <label htmlFor="to">To</label>
                        <input
                            type="text"
                            id="to"
                            value={toMailId}
                            disabled={toMailId ? false : true}
                        />
                        <BarLoader color="#948256" loading={toMailId ? false : true} width={"100%"} />
                    </div>
                    <div className="formgroup">
                        <label htmlFor="">Subject</label>
                        <input
                            type="text"
                            id="subject"
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                        />

                    </div>
                    <div className="formgroup">
                        <label htmlFor="">Message</label>
                        <textarea
                            name=""
                            id="message"
                            value={content}
                            onChange={(e) => setContent(e.target.value)}
                        ></textarea>
                    </div>
                </div>
            </div>
            <div className="modal-footer mb-4">
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleSendMail}
                >
                    Send
                </button>
                <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                    onClick={() => setShowCompose(false)}
                >
                    Cancel
                </button>
            </div>
            <SweetAlert
                show={showAlert}
                success={false}
                type={alertType}
                title={alertTitle}
                onConfirm={() => onConfirm()}
                showCancel={showAlertCancel}
                onCancel={() => {
                    setShowAlert(false);
                    setShowAlertCancel(false);
                }}
                cancelBtnText={"No"}
                confirmBtnText={showAlertCancel ? "Yes" : "Ok"}
            ></SweetAlert>
        </>
    )
}

const mapDispatchToProps = {
    sendMail: (Feedback: ISendMail, callback: Function) =>
        createFeedback(Feedback, callback),
    getToMailId: (emailBlockId: number) => getToMailId(emailBlockId)
};

function mapStateToProps(state: any) {
    return {
        toMailId: state.common.toMailId,
        currentUser: state.userDetails.userProfileData
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(FinancialAssistanceCompose);